<p>indicator-sector-add-edit works!</p>
